import React from 'react';
import PropTypes from 'prop-types';

import { getAPPID, isPreorder, enableSelfSetup, checkIsMidnight } from '../../../Helpers/index';
import CommonSection from './commonSection';

const TotalAmount = ({
  showDueToday,
  totalDueTodayAmount,
  dueatshipment,
  taxText,
  showDueMonthly,
  totalDueMonthlyAmount,
  dueMontlyLabel,
  dueMonthlyList,
  isCartVisible = true,
  showIcon = false,
  showCartDetails,
}) => {
  // eslint-disable-next-line consistent-return
  const calculatePrice = (item) => {
    if (item && item.itemType === 'PLAN' && !item.isHomePhone && item.totalAmountWithDiscount) {
      return `$${parseFloat(item.totalAmountWithDiscount).toFixed(2)}`;
    }
  };

  const getRightValueText = () => {
    if (getAPPID() === 'AAL' && enableSelfSetup()) {
      if (checkIsMidnight()) {
        return `$${parseFloat(totalDueMonthlyAmount).toFixed(2)}`;
      }
      return dueMonthlyList.length > 0 ? dueMonthlyList.map(calculatePrice) : '$0.00';
    }
    return `$${parseFloat(totalDueMonthlyAmount).toFixed(2)}`;
  };

  return (
    <>
      {showDueToday && totalDueTodayAmount !== null && totalDueTodayAmount !== '' && totalDueTodayAmount !== undefined && (
        <CommonSection
          leftValueText={isPreorder() ? dueatshipment : 'Due today'}
          rightValueText={`$${parseFloat(totalDueTodayAmount).toFixed(2)}`}
          id="DueToday Info"
          subTitle={isCartVisible && taxText}
          className="headerStyle"
          isCartVisible={isCartVisible}
          showIcon={showIcon}
          toggleCart={showCartDetails}
        />
      )}

      {showDueMonthly && totalDueMonthlyAmount !== null && totalDueMonthlyAmount !== '' && totalDueMonthlyAmount !== undefined && (
        <CommonSection
          leftValueText={dueMontlyLabel || 'Due monthly'}
          rightValueText={getRightValueText()}
          id="DueMonthly Info"
          subTitle={taxText}
          className="headerStyle"
        />
      )}
    </>
  );
};
TotalAmount.propTypes = {
  showDueToday: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  totalDueTodayAmount: PropTypes.string,
  dueatshipment: PropTypes.string,
  taxText: PropTypes.string,
  showDueMonthly: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  totalDueMonthlyAmount: PropTypes.string,
  dueMontlyLabel: PropTypes.string,
  dueMonthlyList: PropTypes.array,
  isCartVisible: PropTypes.bool,
  showIcon: PropTypes.bool,
  showCartDetails: PropTypes.func,
};
export default TotalAmount;
